import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsQuestionCircle, BsPlus, BsDash } from "react-icons/bs";
import "./faq.css";

const faqs = [
  {
    q: "Is digital marketing worth the investment for my business?",
    a: "If your customers are online (which they are), digital marketing is one of the most cost-effective ways to generate consistent leads and scale your business.",
  },
  {
    q: "Do you provide customized marketing strategies?",
    a: "Yes, every business is different. We create tailored strategies based on your goals, target audience, and industry to ensure the best results.",
  },
  {
    q: "Do I need a big budget to get started?",
    a: "Not at all. We help you start with the right budget, test what works, and gradually scale campaigns that deliver results.",
  },
  {
    q: "Will I get regular updates and reports?",
    a: "Yes. We maintain complete transparency with regular updates, performance insights, and clear communication so you always know what’s working.",
  },
  {
    q: "What if I’ve tried marketing before and it didn’t work?",
    a: "That usually happens due to poor targeting or strategy. We analyze what went wrong and create a focused plan designed to generate real, measurable results.",
  },
];

export const Faq = () => {
  const [open, setOpen] = useState(null);

  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section className="faq-section">
      <Container>
        <div className="text-center mb-5">
          <span className="faq-badge">
            <BsQuestionCircle /> FAQ
          </span>
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-sub">
            Have questions about our digital marketing services? Here are quick
            answers to help you understand how we work and how we can grow your
            business.
          </p>
        </div>

        <Row className="justify-content-center">
          <Col xs={12} lg={8}>
            {faqs.map((f, i) => (
              <div
                key={i}
                className={`faq-item ${open === i ? "open" : ""}`}
                onClick={() => toggle(i)}
              >
                <div className="faq-question">
                  <span>{f.q}</span>
                  <span className="faq-icon">
                    {open === i ? <BsDash /> : <BsPlus />}
                  </span>
                </div>
                {open === i && <div className="faq-answer">{f.a}</div>}
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};
